import $ from 'jquery';
import BasePropertyView from 'BasePropertyView';
import { Model } from 'backbone';
import contentTemplate from 'behaviors/properties/main/notify/edit-notification-person.ejs';
import restService from 'RestService';
import SelectItemModalView from 'common-views/SelectItemModalView';
import selectFieldModal from 'common-views/SelectFieldModalView';
import constants from 'Constants';
import listService from 'ListService';
import Spinner from 'spin/spin';
import userService from 'UserService';
import util from 'util/Util';


class EditNotificationPersonView extends  BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#editNotificationPerson';
        this.factoryKey = opts.factoryKey;
        this.table = constants.PROP_MAIN_TABLE_NOTIFICATION_VIEW;
        this.Spinner = new Spinner();

        this.model.set('notificationPersonArray', ['Person currently viewing the app', 'Person assigned to this role',
            'User', 'User-Group', 'Fixed email address', 'Email taken from a field', 'Position' ], {silent:true});

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        if (!this.model.get('personUserName')) {
            this.model.set('personUserName', '', {silent: true})
        }
        if (!this.model.get('personUserId')) {
            this.model.set('personUserId', '', {silent: true})
        }
        if (!this.model.get('personUserGroupName')) {
            this.model.set('personUserGroupName', '', {silent: true})
        }
        if (!this.model.get('personUserGroupId')) {
            this.model.set('personUserGroupId', '', {silent: true})
        }
        if (!this.model.get('personPositionName')) {
            this.model.set('personPositionName', '', {silent: true})
        }
        if (!this.model.get('personPositionId')) {
            this.model.set('personPositionId', '', {silent: true})
        }
        if (!this.model.get('personEmailField')) {
            this.model.set('personEmailField', '', {silent: true})
        }
        if (!this.model.get('personEmailFieldId')) {
            this.model.set('personEmailFieldId', '', {silent: true})
        }
        if (!this.model.get('personEmailLiteral')) {
            this.model.set('personEmailLiteral', '', {silent: true})
        }

        this.events = {
            'change input[name=personType]' : 'updateRadioAttributes',
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'click #personEmailFieldBtn'  : 'showValueFieldModal',
            'click #personUserNameBtn'  : 'showUserName',
            'click #personUserGroupNameBtn'  : 'showUserGroup',
            'click #personPositionNameBtn'  : 'showPosition'
        };

        return this;
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.resetFields();
        this.enableFields(propVal);
        this.model.set('personType', propVal);
        $("input[name=personType][value=" + propVal + "]").prop('checked', true);
        this.updateGrid('personType', propVal);
        this.updateDisplayGridValue(propVal);
    }

    resetFields() {
        $('#personUserName').attr('disabled', true);
        $('#personUserName').attr('readOnly', true);
        $('#personUserNameBtn').attr('disabled', true);
        $('#personUserNameBtn').attr('readOnly', true);
        $('#personUserGroupName').attr('disabled', true);
        $('#personUserGroupName').attr('readOnly', true);
        $('#personUserGroupNameBtn').attr('disabled', true);
        $('#personUserGroupNameBtn').attr('readOnly', true);
        $('#personPositionName').attr('disabled', true);
        $('#personPositionName').attr('readOnly', true);
        $('#personPositionNameBtn').attr('disabled', true);
        $('#personPositionNameBtn').attr('readOnly', true);
        $('#personEmailField').attr('disabled', true);
        $('#personEmailField').attr('readOnly', true);
        $('#personEmailFieldBtn').attr('disabled', true);
        $('#personEmailFieldBtn').attr('readOnly', true);
        $('#personEmailLiteral').attr('disabled', true);
        $('#personEmailLiteral').attr('readOnly', true);
    }

    enableFields(propVal) {
        if (propVal !== '1' && propVal !== '0') {
            const
                propID = $(`input[name=personType][value="${propVal}"]`).attr('id'),
                $selector = propVal === '4' ? $(`#person${propID}`) : $(`#person${propID}Btn`);

            $selector.attr('disabled', false).attr('readOnly', false);
        }
    }

    showValueFieldModal(ev) {
        ev.preventDefault();
        const buttonName = ev.target.name;
        const fieldName = buttonName.replace('Btn', '');
        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get('personEmailFieldId'), {silent:true});

        var sfModal = new selectFieldModal({model: sfModel,  mode: 'insertField'});
        sfModal.render().then((selectedField)=>{
            this.model.set(fieldName, selectedField.name, {silent: true});
            this.model.set(fieldName + 'Id', selectedField.id, {silent: true});

            this.updateGrid(fieldName, selectedField.name);
            this.updateDisplayGridValue($('input[name="personType"]:checked').val());

            if(fieldName === 'personEmailField'){
                $('#'+fieldName).val(selectedField.name);
            }
            else{
                $('#'+fieldName).val(selectedField.name + ' - ' + selectedField.id);
            }
        }).catch(err => console.log(err));
    }


    showUserName(ev){
        let self=this;
        this.Spinner.spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            restService.browseAllUsers().then((userData) => {
                console.log('User Data', userData);
                let items = userService.mapUsers(userData, constants.USER_TYPE_USER);

                const alertView = new SelectItemModalView({
                    model: new Model({
                        items: items,
                        subtitle: 'Select User',
                        personUserId: self.model.get('personUserId'),
                        infiniteScrolling: constants.INFINITE_SCROLL_ENABLED
                    }), spinner : this.Spinner, mappedUsers: true
                });

                alertView.render().then(selectedItemInModal => {
                    if (selectedItemInModal) {
                        let userChosen = {
                            option: 'user',
                            label: selectedItemInModal.label,
                            data: selectedItemInModal.items,
                            id: selectedItemInModal.id
                        };
                        this.model.set('personUserChosen', userChosen, { silent: true });
                        this.model.set('personUserName', userChosen.label);
                        this.model.set('personUserId', userChosen.id);
                        this.updateGrid('personUserName', userChosen.label);
                        this.updateDisplayGridValue($('input[name="personType"]:checked').val());

                        this.render();
                    }
                });
            });
        }, 10);
    }


    showUserGroup(ev){
        let self=this;

        this.Spinner.spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            restService.browseAllUsers().then((userGroupsResponse) => {              

                let items = userService.mapUsers(userGroupsResponse, constants.USER_TYPE_GROUP);
                const alertView = new SelectItemModalView({
                    model: new Model(
                        {
                            items: items, subtitle: 'Select User Group',
                            personGroupId: self.model.get('personUserGroupId'),
                            infiniteScrolling: constants.INFINITE_SCROLL_ENABLED
                        }), spinner : this.Spinner, mappedUsers: true
                });

                alertView.render().then(selectedItemInModal => {
                    if (selectedItemInModal) {
                        this.model.set('personUserGroupChoosen', selectedItemInModal, { silent: true });
                        this.model.set('personUserGroupName', selectedItemInModal.label);
                        this.model.set('personUserGroupId', selectedItemInModal.id);

                        this.updateGrid('personUserGroupName', selectedItemInModal.label);
                        this.updateDisplayGridValue($('input[name="personType"]:checked').val());

                        this.render();
                    }
                });
            });

        }, 10);        
    }


    showPosition(ev){
        let self=this;

        this.Spinner.spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            restService.browseAllUsers().then((positionsResponse) => {
              
                let items = userService.mapUsers(positionsResponse, constants.USER_TYPE_POSITION);
                const alertView = new SelectItemModalView({
                    model: new Model(
                        {
                            items: items,
                            subtitle: 'Select Position',
                            personPositionId: self.model.get('personPositionId'),
                            infiniteScrolling: constants.INFINITE_SCROLL_ENABLED
                        }), spinner: this.Spinner, mappedUsers: true
                });

                alertView.render().then(selectedItemInModal => {
                    console.log('Selected Item', selectedItemInModal);
                    if (selectedItemInModal) {
                        let positionChosen = {
                            option: 'position',
                            label: selectedItemInModal.label,
                            data: selectedItemInModal.items,
                            id: selectedItemInModal.id
                        };
                        this.model.set('personPositionChoosen', positionChosen, { silent: true });
                        this.model.set('personPositionName', positionChosen.label);
                        this.model.set('personPositionId', positionChosen.id);

                        this.updateGrid('personPositionName', selectedItemInModal.label);
                        this.updateDisplayGridValue($('input[name="personType"]:checked').val());

                        this.render();
                    }
                });
            });
        }, 10);  
    }


    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  =  util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        this.model.set(propName, propVal);

        this.updateGrid(propName, propVal);
        this.updateDisplayGridValue($('input[name="personType"]:checked').val());
    }

    updateDisplayGridValue(opt) {

        switch (opt) {
            case '1':  // Person assigned to this role
                this.updateGrid('person', this.getPersonAssignedToThisRole());
                break;
            case '2':  // User
                this.updateGrid('person', this.model.get('personUserName') ? this.model.get('personUserName') : constants.ITEM_EMPTY);
                this.updateGrid('personUserName', this.model.get('personUserName'));
                this.updateGrid('personUserId', this.model.get('personUserId'));
                break;
            case '6':  // User Group
                this.updateGrid('person', this.model.get('personUserGroupName') ? this.model.get('personUserGroupName') : constants.ITEM_EMPTY);
                this.updateGrid('personUserGroupName', this.model.get('personUserGroupName'));
                this.updateGrid('personUserGroupId', this.model.get('personUserGroupId'));
                break;
            case '3':  // Position
                this.updateGrid('person', this.model.get('personPositionName') ? this.model.get('personPositionName') : constants.ITEM_EMPTY);
                this.updateGrid('personPositionName', this.model.get('personPositionName'));
                this.updateGrid('personPositionId', this.model.get('personPositionId'));
                break;
            case '5':  // Email taken from a field
                this.updateGrid('person', this.model.get('notificationPersonArray')[opt] + ': ' +  this.model.get('personEmailField'));
                this.updateGrid('personEmailFieldName', this.model.get('personEmailFieldName'));
                this.updateGrid('personEmailFieldId', this.model.get('personEmailFieldId'));
                break;
            case '4':  // Fixed email address
                this.updateGrid('person', this.model.get('personEmailLiteral') ? this.model.get('personEmailLiteral') : constants.ITEM_EMPTY);
                break;
            case '0':  // Person currently viewing this item
                this.updateGrid('person', this.model.get('notificationPersonArray')[opt]);
                break;
        }
    }

    updateGrid(field, value) {
        const id = $(this.table).getGridParam('selrow');
        const rowData = $(this.table).getRowData(id);
        rowData[field] = value;
        $(this.table).setRowData(id, rowData);

    }

    // PF-4862
    getPersonAssignedToThisRole() {
        const
            $table = $(this.table),
            id = $table.getGridParam('selrow'),
            rowData = $table.getRowData(id),
            roleId = rowData.roleId;

        let role = roleId ? listService.getWorkflowRole(roleId) : null;
        return role ? role.personName : constants.ITEM_EMPTY;
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        if (this.model.get('personType')) {
            $("input[name=personType][value=" +
                this.model.get('personType') + "]").prop('checked', true);
            this.enableFields(this.model.get('personType'));
        }

        return this;

    }
}

export default EditNotificationPersonView;
